<div class="flex flex-lg-column">
  <div class="flex flex--row">
    <div class="column_first flex">
      <div class="flex flex--column flex--box">
        <div class="flex">
          <mat-card class="personal">
            <mat-card-content>
              <div class="flex flex--row flex--center" *ngIf="company">
                <div *ngIf="editable">
                  <img *ngIf="cover_photo" [src]="cover_photo" alt="">
                  <button *ngIf="cover_photo" mat-icon-button (click)="removeCover()" class="delete">
                    <mat-icon class="text__color--red">delete</mat-icon>
                  </button>
                  <div *ngIf="!cover_photo" class="flex flex--column flex--center flex--box upload">
                    <input accept="image/*" (change)="uploadPhoto($event.target.files[0])" id="cover_photo" type="file"
                           placeholder="Add Profile Photo" hidden>
                    <label class="block--click flex flex--column flex--center" for="cover_photo">
                      <mat-icon class="text__color--brown-grey font__size--35">add_a_photo</mat-icon>
                      <p>UPLOAD A PHOTO</p>
                      <span class="text__color--brown-grey">Click here to upload a company photo</span>
                    </label>
                  </div>
                </div>
                <div *ngIf="!editable" class="flex flex--column flex--center flex--box">
                  <img *ngIf="cover_photo" [src]="cover_photo" alt="">
                  <label *ngIf="!cover_photo">No company photo</label>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
    </div>

    <div class="flex flex--box" *ngIf="!editable && company">
      <mat-card class="personal">
        <mat-card-content>
          <div class="flex flex--row">
            <div class="flex flex--column flex--box">
              <span textSize="14" textWeight="bold" textColor="black-two">Contact Details</span>
              <div class="column-item flex flex--column">
                <label class="text__color--brown-grey font__size--10">Name</label>
                <label>{{company.name}}</label>
              </div>
              <div class="column-item flex flex--column">
                <label class="text__color--brown-grey font__size--10">Company Address</label>
                <label>{{company.address}}/ {{company.city}}/
                  {{company.state}}/ {{company.zip}}</label>
              </div>
              <div class="column-item flex flex--column">
                <label class="text__color--brown-grey font__size--10">Company Contact Name</label>
                <label>{{company.contactPersonFirstName}}
                  {{company.contactPersonLastName}}</label>
              </div>
              <div class="column-item flex flex--column">
                <label class="text__color--brown-grey font__size--10">Phone</label>
                <label>
                  <a class="text__color--dark" href="tel:{{company.officePhone}}">
                    {{company.officePhone}}
                  </a>
                </label>
              </div>
              <div class="column-item flex flex--column">
                <label class="text__color--brown-grey font__size--10">Email</label>
                <label><a class="text__color--dark" href="mailto:{{company.email}}" target="_blank">
                  {{company.email}}
                </a></label>
              </div>
            </div>
            <div class="flex flex--column flex--box">
              <span textSize="14" textWeight="bold" textColor="black-two">Company Details</span>
              <div class="column-item flex flex--column">
                <label class="text__color--brown-grey font__size--10">DOT Number</label>
                <label>{{company.dotNumber}}</label>
              </div>
              <div class="column-item flex flex--column">
                <label class="text__color--brown-grey font__size--10">MS Number</label>
                <label>{{company.msNumber}}</label>
              </div>
              <div class="column-item flex flex--column">
                <label class="text__color--brown-grey font__size--10">Insurance</label>
                <label>
                  <a class="flex--box register__form--file text__color--dark"
                     *ngIf="company.insuranceUrl" [href]="company.insuranceUrl" target="_blank">Insurance
                    Url</a>
                </label>
              </div>
              <div class="column-item flex flex--column">
                <label class="text__color--brown-grey font__size--10">MC Certificate</label>
                <label>
                  <a class="flex--box register__form--file text__color--dark"
                     *ngIf="company.mcCertificateUrl" [href]="company.mcCertificateUrl" target="_blank">Mc Certificate
                    Url</a>
                </label>
              </div>
              <div class="column-item flex flex--column">
                <label class="text__color--brown-grey font__size--10">Status</label>
                <label>
                  {{company.blocked ? "Block" : "Active"}}
                </label>
              </div>
            </div>
          </div>
        </mat-card-content>
        <mat-card-actions class="text--right" *ngIf="user.roleId === roles.COMPANY_ADMIN">
          <button (click)="edit()" class="login__form--button" mat-icon-button color="primary">
            <i class="material-icons">
              lock
            </i>
          </button>
        </mat-card-actions>
      </mat-card>
    </div>
    <div *ngIf="editable" class="column_second flex flex--box">
      <form [formGroup]="data" class="flex flex--row">
        <mat-card class="personal">
          <mat-card-content>
            <div class="flex flex--row">
              <div class="column column-form flex column-width flex--column">
                <div class="flex flex--column flex--box">
                  <mat-form-field>
                    <input [matAutocomplete]="addressAuto" type="text" formControlName="address" matInput placeholder="Address"
                           (ngModelChange)="addressValidator($event)">
                  </mat-form-field>
                  <mat-autocomplete
                    #addressAuto="matAutocomplete"
                    [displayWith]="displayAddressOption"
                    (optionSelected)="setAddress($event.option.value)"
                  >
                    <mat-option *ngFor="let option of addressLocationOptions$ | async" [value]="option">
                      {{ option.label }}
                    </mat-option>
                  </mat-autocomplete>
                  <mat-form-field>
                    <input type="text" formControlName="officePhone" matInput placeholder="Phone">
                  </mat-form-field>
                </div>
              </div>
              <div class="column column-form flex column-width flex--column">
                <div class="flex flex--column">
                  <mat-form-field>
                    <input type="tel" formControlName="contactPersonPhone" matInput placeholder="Contact Person Phone">
                  </mat-form-field>
                </div>

                <div class="register__form--file-picker flex flex--row flex__align-items--center document">
                  <mat-icon>note_add</mat-icon>
                  <span *ngIf="!company.mcCertificateUrl" textSize="13" textColor="brownish-grey"
                        class="flex--box register__form--file">Add Insurance</span>
                  <a class="flex--box register__form--file" *ngIf="company.mcCertificateUrl"
                     [href]="company.mcCertificateUrl" target="_blank">Insurance Url</a>
                  <input accept="image/jpeg,application/pdf"
                         (change)="uploadDocument($event.target.files[0],'mcCertificateUrl')" id="mcCertificate"
                         type="file"
                         placeholder="Add Mc Certificate" hidden>
                  <label textSize="16" textColor="dodger-blue" class="block--click" for="mcCertificate">BROWSE</label>
                </div>

                <div class="register__form--file-picker flex flex--row flex__align-items--center document">
                  <mat-icon>security</mat-icon>
                  <span *ngIf="!company.insuranceUrl" textSize="13" textColor="brownish-grey"
                        class="flex--box register__form--file">Add Insurance</span>
                  <a class="flex--box register__form--file" *ngIf="company.insuranceUrl" [href]="company.insuranceUrl"
                     target="_blank">Insurance Url</a>
                  <input accept="image/jpeg,application/pdf"
                         (change)="uploadDocument($event.target.files[0],'insuranceUrl')" id="insurance" type="file"
                         placeholder="Add Mc Certificate" hidden>
                  <label textSize="16" textColor="dodger-blue" class="block--click" for="insurance">BROWSE</label>
                </div>
              </div>
            </div>
          </mat-card-content>
          <mat-card-actions class="text--right" *ngIf="user.roleId === roles.COMPANY_ADMIN">
            <button (click)="save()" class="login__form--button" mat-icon-button color="primary">
              <i class="material-icons">
                lock_open
              </i>
            </button>
          </mat-card-actions>
        </mat-card>
      </form>
    </div>
  </div>
  <div class="flex flex--row">
    <div [ngStyle]="{'width': '44%'}" class="flex">
      <div class="column-margin flex flex--box">
        <mat-card class="bank-info">
          <mat-card-content>
            <div class="flex flex--row flex__justify-content--space-between flex__align-items--center">
              <div class="column-margin-title">
                {{company && user.roleId === roles.COMPANY_ADMIN ? 'Permits' : 'Carrier Fleet Docs'}}
              </div>
              <div class="flex flex--row column-margin-file">
                <div *ngIf="company && user.roleId === roles.COMPANY_ADMIN">
                  <input #document (change)="uploadAttachments($event.target.files[0])" id="attachments" type="file"
                         placeholder="Add Permits" hidden>
                  <label class="flex flex--column flex--center" for="attachments">
                    <p>Add</p>
                  </label>
                </div>
              </div>
            </div>
            <div class="flex flex--column" *ngIf="company && company.files">
              <div class="attachments flex flex--row flex__justify-content--space-between flex__align-items--center"
                   *ngFor="let file of company.files">
                <div class="flex flex--row flex__align-items--center">
                  <i class="material-icons" textColor="brown-grey">
                    attach_file
                  </i>
                  <span class="attachments--name">{{file.displayName}}</span>
                </div>
                <div class="flex flex--row flex__align-items--center">
                  <button mat-icon-button (click)="downloadAttachment(file)">
                    <mat-icon>file_copy</mat-icon>
                  </button>
                  <button mat-icon-button (click)="removeAttachment(file.id)"
                          *ngIf="company && user.roleId === roles.COMPANY_ADMIN">
                    <mat-icon>delete_outline</mat-icon>
                  </button>
                </div>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
    <div class="bank-info-row flex flex--row" *ngIf="companyWallet && companyWallet.details">
      <mat-card class="bank-info">
        <mat-card-content>
          <div class="flex flex--row">
            <div class="flex flex--column flex--box">
              <span textSize="14" textWeight="bold" textColor="black-two">Bank info</span>

              <div class="column-item flex flex--column">
                <label class="text__color--brown-grey font__size--10">Status</label>
                <label>{{companyWallet.status}}</label>
              </div>

              <div class="column-item flex flex--column">
                <label class="text__color--brown-grey font__size--10">Routing Number</label>
                <label>{{companyWallet.details.routingNumber}}</label>
              </div>

              <div class="column-item flex flex--column">
                <label class="text__color--brown-grey font__size--10">Account Number</label>
                <label>{{companyWallet.details.last4}}</label>
              </div>

              <div class="column-item flex flex--column">
                You authorized Braintree, a service of PayPal, on behalf of {{company && company.name}}, to verify your
                account information using bank information and consumer reports and to debit or credit your account
              </div>
            </div>
          </div>
        </mat-card-content>
        <mat-card-actions class="text--right" *ngIf="user.roleId === roles.COMPANY_ADMIN">
          <button (click)="deleteCompanyWallet()" class="login__form--button" mat-icon-button color="primary">
            <i class="material-icons">
              delete
            </i>
          </button>
        </mat-card-actions>
      </mat-card>
    </div>
    <div *ngIf="!companyWallet || !companyWallet.details" class="bank-info-row flex flex--row">
      <form [formGroup]="bankInfoForm" class="flex flex--row">
        <mat-card class="personal">
          <mat-card-content>
            <div class="flex flex--row">
              <div class="column column-form flex column-width flex--column">
                <div class="flex flex--column flex--box">
                  <span textSize="14" textWeight="bold" textColor="black-two">Bank info</span>

                  <mat-form-field>
                    <input type="text" formControlName="accountNumber" matInput placeholder="Account Number"
                           (ngModelChange)="addressValidator($event)">
                  </mat-form-field>
                  <mat-form-field>
                    <input type="text" formControlName="routingNumber" matInput placeholder="Routing Number"
                           (ngModelChange)="addressValidator($event)">
                  </mat-form-field>
                </div>
              </div>
            </div>
          </mat-card-content>
          <mat-card-actions class="text--right" *ngIf="user.roleId === roles.COMPANY_ADMIN">
            <button mat-mini-fab color="primary" (click)="openAddWalletDialog()">
              <mat-icon>add</mat-icon>
            </button>
          </mat-card-actions>
        </mat-card>
      </form>
    </div>
  </div>
</div>
